var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20.006,
    viewBox: "0 0 20 20.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 20,
    height: 20.006,
    transform: "translate(0 0)",
    fill: "#30b524"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47567",
    "data-name": "Path 47567",
    d: "M3,16.006H7.24a1,1,0,0,0,.71-.29l6.92-6.93,2.84-2.78a1,1,0,0,0,.006-1.414l-.006-.006L13.47.3A1,1,0,0,0,12.056.29L12.05.3,9.23,3.126l-6.94,6.93a1,1,0,0,0-.29.71v4.24a1,1,0,0,0,1,1m9.76-13.59,2.83,2.83-1.42,1.42-2.83-2.83ZM4,11.176l5.93-5.93,2.83,2.83-5.93,5.93H4Zm15,6.83H1a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2",
    fill: "#30b524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDetails);
export default __webpack_public_path__ + "static/media/EditDetails.69d39f7c77ee2bc94b0eb4d19c018cb8.svg";
export { ForwardRef as ReactComponent };